webpackJsonp([8],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"add-module-exports\",\"add-module-exports\",\"transform-object-assign\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"babel-plugin-glamor\"],\"presets\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-env/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _HeaderNav = __webpack_require__("./src/components/HeaderNav.js");
	
	var _HeaderNav2 = _interopRequireDefault(_HeaderNav);
	
	__webpack_require__("./src/reset.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: "render",
	    value: function render() {
	      var location = this.props.location;
	
	      if (location.pathname === '/') {
	        return this.props.children();
	      }
	      if (true) {
	        return this.props.children();
	      }
	
	      var accent = '#db4d3f';
	      return Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(_reactHelmet2.default, {
	          title: "Reason: JavaScript-flavored OCaml"
	        }),
	        Glamor.createElement(
	          "div",
	          {
	            style: {
	              backgroundColor: accent,
	              marginBottom: (0, _typography.rhythm)(1),
	              flexDirection: 'row',
	              justifyContent: 'center'
	            }
	          },
	          Glamor.createElement(
	            "div",
	            {
	              style: {
	                flex: 1,
	                flexDirection: 'row',
	                justifyContent: 'space-between',
	                // margin: `0 auto`,
	                maxWidth: 960,
	                padding: (0, _typography.rhythm)(1) + " " + (0, _typography.rhythm)(3 / 4)
	              }
	            },
	            Glamor.createElement(
	              "h1",
	              { style: { margin: 0 } },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: "/",
	                  style: {
	                    color: "white",
	                    textDecoration: "none"
	                  }
	                },
	                "Reason"
	              )
	            ),
	            Glamor.createElement(_HeaderNav2.default, null)
	          )
	        ),
	        Glamor.createElement(
	          "div",
	          { css: { alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'center' } },
	          Glamor.createElement(
	            "div",
	            {
	              style: {
	                maxWidth: 960,
	                flex: 1,
	                padding: (0, _typography.rhythm)(1) + " " + (0, _typography.rhythm)(3 / 4),
	                paddingTop: 0
	              }
	            },
	            this.props.children()
	          )
	        )
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = Template;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }),

/***/ "./src/reset.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "div{display:flex;flex-direction:column;flex-shrink:0;min-width:0;align-items:stretch}button,input{background:none;border:none;outline:none}pre{@media (max-width:550px){white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}}body{@media (max-width:550px){overflow:hidden;width:100%}}", ""]);
	
	// exports


/***/ })

});


// WEBPACK FOOTER //
// layout-component---index-97b136593a02d20e1646.js